webpackJsonp([58],{

/***/ 1271:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_new_type_form_vue__ = __webpack_require__(1894);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_84ecc17e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_new_type_form_vue__ = __webpack_require__(2301);
function injectStyle (ssrContext) {
  __webpack_require__(2299)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-84ecc17e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_new_type_form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_84ecc17e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_new_type_form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1372:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "withParams", {
  enumerable: true,
  get: function get() {
    return _withParams.default;
  }
});
exports.regex = exports.ref = exports.len = exports.req = void 0;

var _withParams = _interopRequireDefault(__webpack_require__(1438));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var req = function req(value) {
  if (Array.isArray(value)) return !!value.length;

  if (value === undefined || value === null) {
    return false;
  }

  if (value === false) {
    return true;
  }

  if (value instanceof Date) {
    return !isNaN(value.getTime());
  }

  if (_typeof(value) === 'object') {
    for (var _ in value) {
      return true;
    }

    return false;
  }

  return !!String(value).length;
};

exports.req = req;

var len = function len(value) {
  if (Array.isArray(value)) return value.length;

  if (_typeof(value) === 'object') {
    return Object.keys(value).length;
  }

  return String(value).length;
};

exports.len = len;

var ref = function ref(reference, vm, parentVm) {
  return typeof reference === 'function' ? reference.call(vm, parentVm) : parentVm[reference];
};

exports.ref = ref;

var regex = function regex(type, expr) {
  return (0, _withParams.default)({
    type: type
  }, function (value) {
    return !req(value) || expr.test(value);
  });
};

exports.regex = regex;

/***/ }),

/***/ 1377:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'close-icon',
	props: {
		color: {
			type: String,
			default: '#F09C2B' // Color naranja por defecto para no afectar otros sitios
		}
	}
});

/***/ }),

/***/ 1378:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_close_icon_vue__ = __webpack_require__(1377);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6aaa07f0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_close_icon_vue__ = __webpack_require__(1398);
function injectStyle (ssrContext) {
  __webpack_require__(1396)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6aaa07f0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_close_icon_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6aaa07f0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_close_icon_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1396:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1397);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1266)("21d43010", content, true, {});

/***/ }),

/***/ 1397:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1265)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"close-icon.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 1398:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"12","height":"12","xmlns":"http://www.w3.org/2000/svg"},on:{"click":function($event){_vm.$emit('click')}}},[_c('g',{attrs:{"stroke":_vm.color,"stroke-width":"2","fill":"none","fill-rule":"evenodd","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"m1 1 9.783 9.737M10.783 1 1 10.737"}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1424:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modules_shared_components_icons_close_icon__ = __webpack_require__(1378);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'open-modal',
	components: {
		CloseIcon: __WEBPACK_IMPORTED_MODULE_0__modules_shared_components_icons_close_icon__["a" /* default */]
	},
	props: {
		dialog: {
			type: Boolean,
			default: false
		},
		create: {
			type: Boolean,
			default: true
		},
		footer: {
			default: true,
			type: Boolean
		},
		title: {
			type: String,
			default: ''
		},
		color: {
			type: String,
			default: 'primary'
		},
		smallModel: {
			type: Boolean,
			default: false
		},
		height: {
			default: 80
		},
		closeModel: {
			type: Boolean,
			default: false
		},
		persistent: {
			type: Boolean,
			default: false
		}
	}
});

/***/ }),

/***/ 1429:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "alpha", {
  enumerable: true,
  get: function get() {
    return _alpha.default;
  }
});
Object.defineProperty(exports, "alphaNum", {
  enumerable: true,
  get: function get() {
    return _alphaNum.default;
  }
});
Object.defineProperty(exports, "numeric", {
  enumerable: true,
  get: function get() {
    return _numeric.default;
  }
});
Object.defineProperty(exports, "between", {
  enumerable: true,
  get: function get() {
    return _between.default;
  }
});
Object.defineProperty(exports, "email", {
  enumerable: true,
  get: function get() {
    return _email.default;
  }
});
Object.defineProperty(exports, "ipAddress", {
  enumerable: true,
  get: function get() {
    return _ipAddress.default;
  }
});
Object.defineProperty(exports, "macAddress", {
  enumerable: true,
  get: function get() {
    return _macAddress.default;
  }
});
Object.defineProperty(exports, "maxLength", {
  enumerable: true,
  get: function get() {
    return _maxLength.default;
  }
});
Object.defineProperty(exports, "minLength", {
  enumerable: true,
  get: function get() {
    return _minLength.default;
  }
});
Object.defineProperty(exports, "required", {
  enumerable: true,
  get: function get() {
    return _required.default;
  }
});
Object.defineProperty(exports, "requiredIf", {
  enumerable: true,
  get: function get() {
    return _requiredIf.default;
  }
});
Object.defineProperty(exports, "requiredUnless", {
  enumerable: true,
  get: function get() {
    return _requiredUnless.default;
  }
});
Object.defineProperty(exports, "sameAs", {
  enumerable: true,
  get: function get() {
    return _sameAs.default;
  }
});
Object.defineProperty(exports, "url", {
  enumerable: true,
  get: function get() {
    return _url.default;
  }
});
Object.defineProperty(exports, "or", {
  enumerable: true,
  get: function get() {
    return _or.default;
  }
});
Object.defineProperty(exports, "and", {
  enumerable: true,
  get: function get() {
    return _and.default;
  }
});
Object.defineProperty(exports, "not", {
  enumerable: true,
  get: function get() {
    return _not.default;
  }
});
Object.defineProperty(exports, "minValue", {
  enumerable: true,
  get: function get() {
    return _minValue.default;
  }
});
Object.defineProperty(exports, "maxValue", {
  enumerable: true,
  get: function get() {
    return _maxValue.default;
  }
});
Object.defineProperty(exports, "integer", {
  enumerable: true,
  get: function get() {
    return _integer.default;
  }
});
Object.defineProperty(exports, "decimal", {
  enumerable: true,
  get: function get() {
    return _decimal.default;
  }
});
exports.helpers = void 0;

var _alpha = _interopRequireDefault(__webpack_require__(1437));

var _alphaNum = _interopRequireDefault(__webpack_require__(1440));

var _numeric = _interopRequireDefault(__webpack_require__(1441));

var _between = _interopRequireDefault(__webpack_require__(1442));

var _email = _interopRequireDefault(__webpack_require__(1443));

var _ipAddress = _interopRequireDefault(__webpack_require__(1444));

var _macAddress = _interopRequireDefault(__webpack_require__(1445));

var _maxLength = _interopRequireDefault(__webpack_require__(1446));

var _minLength = _interopRequireDefault(__webpack_require__(1447));

var _required = _interopRequireDefault(__webpack_require__(1448));

var _requiredIf = _interopRequireDefault(__webpack_require__(1449));

var _requiredUnless = _interopRequireDefault(__webpack_require__(1450));

var _sameAs = _interopRequireDefault(__webpack_require__(1451));

var _url = _interopRequireDefault(__webpack_require__(1452));

var _or = _interopRequireDefault(__webpack_require__(1453));

var _and = _interopRequireDefault(__webpack_require__(1454));

var _not = _interopRequireDefault(__webpack_require__(1455));

var _minValue = _interopRequireDefault(__webpack_require__(1456));

var _maxValue = _interopRequireDefault(__webpack_require__(1457));

var _integer = _interopRequireDefault(__webpack_require__(1458));

var _decimal = _interopRequireDefault(__webpack_require__(1459));

var helpers = _interopRequireWildcard(__webpack_require__(1372));

exports.helpers = helpers;

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 1433:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_open_modal_vue__ = __webpack_require__(1424);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_80c9bba8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_open_modal_vue__ = __webpack_require__(1436);
function injectStyle (ssrContext) {
  __webpack_require__(1434)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-80c9bba8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_open_modal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_80c9bba8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_open_modal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1434:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1435);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1266)("a109abf6", content, true, {});

/***/ }),

/***/ 1435:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1265)(true);
// imports


// module
exports.push([module.i, "@font-face{font-family:Lato_regular;src:url(\"/static/fonts/Lato-Regular.ttf\");font-weight:400;font-style:normal}@font-face{font-family:NeuzeitGroT;src:url(\"/static/fonts/NeuzeitGroT.eot\");src:url(\"/static/fonts/NeuzeitGroT.ttf\") format(\"truetype\"),url(\"/static/fonts/NeuzeitGroT.woff\") format(\"woff\");font-weight:400;font-style:normal}@font-face{font-family:NeuzeitGroTBold;src:url(\"/static/fonts/NeuzeitGroTBold.eot\");src:url(\"/static/fonts/NeuzeitGroTBold.ttf\") format(\"truetype\"),url(\"/static/fonts/NeuzeitGroTBold.woff\") format(\"woff\");font-weight:400;font-style:normal}@font-face{font-family:NeuzeitGroTLig;src:url(\"/static/fonts/NeuzeitGroLig.eot\");src:url(\"/static/fonts/NeuzeitGroTLig.ttf\") format(\"truetype\"),url(\"/static/fonts/NeuzeitGroTLig.woff\") format(\"woff\");font-weight:400;font-style:normal}@font-face{font-family:NeuzeitGroTBla;src:url(\"/static/fonts/NeuzeitGroTBla.eot\");src:url(\"/static/fonts/NeuzeitGroTBla.ttf\") format(\"truetype\"),url(\"/static/fonts/NeuzeitGroTBla.woff\") format(\"woff\");font-weight:400;font-style:normal}.open-modal[data-v-80c9bba8]{background-color:#f9f9f9;-webkit-box-shadow:0 2px 21px 0 rgba(68,68,68,.5);box-shadow:0 2px 21px 0 rgba(68,68,68,.5);position:relative;width:100%}@media (max-width:768px){.open-modal[data-v-80c9bba8]{width:100%;zoom:100%}}.background-footer-modal[data-v-80c9bba8]{background-color:#fff;bottom:0;left:0;padding:1px;position:absolute;width:100%}.v-dialog[data-v-80c9bba8]{margin:0!important}.design-scale-chart-close[data-v-80c9bba8]{position:absolute;right:20px;top:20px}", "", {"version":3,"sources":["/opt/build/repo/src/components/configuration/open-modal.vue"],"names":[],"mappings":"AACA,WACE,yBAA4B,AAC5B,0CAA2C,AAC3C,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,wBAA2B,AAC3B,yCAA0C,AAC1C,iHAAmH,AACnH,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,4BAA+B,AAC/B,6CAA8C,AAC9C,yHAA2H,AAC3H,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,2BAA8B,AAC9B,2CAA4C,AAC5C,uHAAyH,AACzH,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,2BAA8B,AAC9B,4CAA6C,AAC7C,uHAAyH,AACzH,gBAAoB,AACpB,iBAAmB,CACpB,AACD,6BACE,yBAA0B,AAC1B,kDAAuD,AAC/C,0CAA+C,AACvD,kBAAmB,AACnB,UAAY,CACb,AACD,yBACA,6BACM,WAAY,AACZ,SAAW,CAChB,CACA,AACD,0CACE,sBAA0B,AAC1B,SAAU,AACV,OAAQ,AACR,YAAa,AACb,kBAAmB,AACnB,UAAY,CACb,AACD,2BACE,kBAAqB,CACtB,AACD,2CACE,kBAAmB,AACnB,WAAY,AACZ,QAAU,CACX","file":"open-modal.vue","sourcesContent":["\n@font-face {\n  font-family: 'Lato_regular';\n  src: url(\"/static/fonts/Lato-Regular.ttf\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'NeuzeitGroT';\n  src: url(\"/static/fonts/NeuzeitGroT.eot\");\n  src: url(\"/static/fonts/NeuzeitGroT.ttf\") format(\"truetype\"), url(\"/static/fonts/NeuzeitGroT.woff\") format(\"woff\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'NeuzeitGroTBold';\n  src: url(\"/static/fonts/NeuzeitGroTBold.eot\");\n  src: url(\"/static/fonts/NeuzeitGroTBold.ttf\") format(\"truetype\"), url(\"/static/fonts/NeuzeitGroTBold.woff\") format(\"woff\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'NeuzeitGroTLig';\n  src: url(\"/static/fonts/NeuzeitGroLig.eot\");\n  src: url(\"/static/fonts/NeuzeitGroTLig.ttf\") format(\"truetype\"), url(\"/static/fonts/NeuzeitGroTLig.woff\") format(\"woff\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'NeuzeitGroTBla';\n  src: url(\"/static/fonts/NeuzeitGroTBla.eot\");\n  src: url(\"/static/fonts/NeuzeitGroTBla.ttf\") format(\"truetype\"), url(\"/static/fonts/NeuzeitGroTBla.woff\") format(\"woff\");\n  font-weight: normal;\n  font-style: normal;\n}\n.open-modal[data-v-80c9bba8] {\n  background-color: #f9f9f9;\n  -webkit-box-shadow: 0 2px 21px 0 rgba(68, 68, 68, 0.5);\n          box-shadow: 0 2px 21px 0 rgba(68, 68, 68, 0.5);\n  position: relative;\n  width: 100%;\n}\n@media (max-width: 768px) {\n.open-modal[data-v-80c9bba8] {\n      width: 100%;\n      zoom: 100%;\n}\n}\n.background-footer-modal[data-v-80c9bba8] {\n  background-color: #ffffff;\n  bottom: 0;\n  left: 0;\n  padding: 1px;\n  position: absolute;\n  width: 100%;\n}\n.v-dialog[data-v-80c9bba8] {\n  margin: 0 !important;\n}\n.design-scale-chart-close[data-v-80c9bba8] {\n  position: absolute;\n  right: 20px;\n  top: 20px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1436:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"value":_vm.dialog,"persistent":_vm.persistent,"max-width":"950%"},on:{"input":function($event){_vm.$emit('close-modal', $event)}}},[_c('div',[_c('v-card',{staticClass:"new-survey open-modal",style:(("height: " + _vm.height + "%;"))},[(_vm.closeModel)?_c('div',{staticClass:"design-scale-chart-close"},[_c('close-icon',{staticClass:"cursor-pointer",on:{"click":function($event){_vm.$emit('close', $event)}}})],1):_vm._e(),_vm._v(" "),_vm._t("default")],2),_vm._v(" "),(_vm.footer)?_c('div',{staticClass:"background-footer-modal"},[_c('v-layout',{attrs:{"wrap":"","justify-center":""}},[_c('v-flex',{attrs:{"xs2":"","mx-1":""}},[_c('v-btn',{staticClass:"btn btn-action btn-disabled-background",attrs:{"color":_vm.color,"type":"button","disabled":_vm.create},on:{"click":function($event){_vm.$emit('create-employee')}}},[_vm._v("\n\t\t\t\t\t\t"+_vm._s(_vm.title)+"\n\t\t\t\t\t")])],1)],1)],1):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1437:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(1372);

var _default = (0, _common.regex)('alpha', /^[a-zA-Z]*$/);

exports.default = _default;

/***/ }),

/***/ 1438:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var withParams = Object({"NODE_ENV":"production","APP_CODE":'praktiko-admin',"APP_NAME":'"praktiko"',"PRAKTIKO_URL":'https://temp-praktiko.apprunn.net/',"MOCK_URL":'undefined',"ACL_URL":'https://temp-acl-praktiko.apprunn.net/api',"STORAGE_USER_KEY":"praktiko","S3_IMAGES_URL":'https://praktiko-main.s3.us-east-1.amazonaws.com/iconos',"COMPANY_LOGIN_TITLE":'Praktiko',"POLL_ENGINE":'https://temp-pollengine.apprunn.net/',"UPLOAD_URL":'undefined',"COMPANY_LOGO_SMALL":'undefined',"COMPANY_LOGO":'undefined',"COLORS":'{"sidebar": "#efefef","primary": "#55ac4b","secondary": "#f09c2b","success": "#5ed52b","white": "#ffffff","gray": "#e9e9e9","info": "#606560","accent": "#005CAF","error": "#f42b17","warning": "#FFB74C"}',"LOGO_LOGIN":'https://praktiko-main.s3.us-east-1.amazonaws.com/iconos/Icons+sidebar/logo-praktico-login.png',"LOGO_SMALL":'https://praktiko-main.s3.us-east-1.amazonaws.com/iconos/Icons+sidebar/logo-small.png',"LOGO":'https://praktiko-main.s3.us-east-1.amazonaws.com/iconos/Icons+sidebar/logo-praktiko-slider.png',"CREDENTIAL_SCRAPER":'http://34.204.114.234:8080/'}).BUILD === 'web' ? __webpack_require__(1439).withParams : __webpack_require__(524).withParams;
var _default = withParams;
exports.default = _default;

/***/ }),

/***/ 1439:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withParams = void 0;

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var root = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : {};

var fakeWithParams = function fakeWithParams(paramsOrClosure, maybeValidator) {
  if (_typeof(paramsOrClosure) === 'object' && maybeValidator !== undefined) {
    return maybeValidator;
  }

  return paramsOrClosure(function () {});
};

var withParams = root.vuelidate ? root.vuelidate.withParams : fakeWithParams;
exports.withParams = withParams;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(523)))

/***/ }),

/***/ 1440:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(1372);

var _default = (0, _common.regex)('alphaNum', /^[a-zA-Z0-9]*$/);

exports.default = _default;

/***/ }),

/***/ 1441:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(1372);

var _default = (0, _common.regex)('numeric', /^[0-9]*$/);

exports.default = _default;

/***/ }),

/***/ 1442:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(1372);

var _default = function _default(min, max) {
  return (0, _common.withParams)({
    type: 'between',
    min: min,
    max: max
  }, function (value) {
    return !(0, _common.req)(value) || (!/\s/.test(value) || value instanceof Date) && +min <= +value && +max >= +value;
  });
};

exports.default = _default;

/***/ }),

/***/ 1443:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(1372);

var emailRegex = /(^$|^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$)/;

var _default = (0, _common.regex)('email', emailRegex);

exports.default = _default;

/***/ }),

/***/ 1444:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(1372);

var _default = (0, _common.withParams)({
  type: 'ipAddress'
}, function (value) {
  if (!(0, _common.req)(value)) {
    return true;
  }

  if (typeof value !== 'string') {
    return false;
  }

  var nibbles = value.split('.');
  return nibbles.length === 4 && nibbles.every(nibbleValid);
});

exports.default = _default;

var nibbleValid = function nibbleValid(nibble) {
  if (nibble.length > 3 || nibble.length === 0) {
    return false;
  }

  if (nibble[0] === '0' && nibble !== '0') {
    return false;
  }

  if (!nibble.match(/^\d+$/)) {
    return false;
  }

  var numeric = +nibble | 0;
  return numeric >= 0 && numeric <= 255;
};

/***/ }),

/***/ 1445:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(1372);

var _default = function _default() {
  var separator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ':';
  return (0, _common.withParams)({
    type: 'macAddress'
  }, function (value) {
    if (!(0, _common.req)(value)) {
      return true;
    }

    if (typeof value !== 'string') {
      return false;
    }

    var parts = typeof separator === 'string' && separator !== '' ? value.split(separator) : value.length === 12 || value.length === 16 ? value.match(/.{2}/g) : null;
    return parts !== null && (parts.length === 6 || parts.length === 8) && parts.every(hexValid);
  });
};

exports.default = _default;

var hexValid = function hexValid(hex) {
  return hex.toLowerCase().match(/^[0-9a-f]{2}$/);
};

/***/ }),

/***/ 1446:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(1372);

var _default = function _default(length) {
  return (0, _common.withParams)({
    type: 'maxLength',
    max: length
  }, function (value) {
    return !(0, _common.req)(value) || (0, _common.len)(value) <= length;
  });
};

exports.default = _default;

/***/ }),

/***/ 1447:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(1372);

var _default = function _default(length) {
  return (0, _common.withParams)({
    type: 'minLength',
    min: length
  }, function (value) {
    return !(0, _common.req)(value) || (0, _common.len)(value) >= length;
  });
};

exports.default = _default;

/***/ }),

/***/ 1448:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(1372);

var _default = (0, _common.withParams)({
  type: 'required'
}, _common.req);

exports.default = _default;

/***/ }),

/***/ 1449:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(1372);

var _default = function _default(prop) {
  return (0, _common.withParams)({
    type: 'requiredIf',
    prop: prop
  }, function (value, parentVm) {
    return (0, _common.ref)(prop, this, parentVm) ? (0, _common.req)(value) : true;
  });
};

exports.default = _default;

/***/ }),

/***/ 1450:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(1372);

var _default = function _default(prop) {
  return (0, _common.withParams)({
    type: 'requiredUnless',
    prop: prop
  }, function (value, parentVm) {
    return !(0, _common.ref)(prop, this, parentVm) ? (0, _common.req)(value) : true;
  });
};

exports.default = _default;

/***/ }),

/***/ 1451:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(1372);

var _default = function _default(equalTo) {
  return (0, _common.withParams)({
    type: 'sameAs',
    eq: equalTo
  }, function (value, parentVm) {
    return value === (0, _common.ref)(equalTo, this, parentVm);
  });
};

exports.default = _default;

/***/ }),

/***/ 1452:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(1372);

var urlRegex = /^(?:(?:https?|ftp):\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:[/?#]\S*)?$/i;

var _default = (0, _common.regex)('url', urlRegex);

exports.default = _default;

/***/ }),

/***/ 1453:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(1372);

var _default = function _default() {
  for (var _len = arguments.length, validators = new Array(_len), _key = 0; _key < _len; _key++) {
    validators[_key] = arguments[_key];
  }

  return (0, _common.withParams)({
    type: 'or'
  }, function () {
    var _this = this;

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return validators.length > 0 && validators.reduce(function (valid, fn) {
      return valid || fn.apply(_this, args);
    }, false);
  });
};

exports.default = _default;

/***/ }),

/***/ 1454:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(1372);

var _default = function _default() {
  for (var _len = arguments.length, validators = new Array(_len), _key = 0; _key < _len; _key++) {
    validators[_key] = arguments[_key];
  }

  return (0, _common.withParams)({
    type: 'and'
  }, function () {
    var _this = this;

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return validators.length > 0 && validators.reduce(function (valid, fn) {
      return valid && fn.apply(_this, args);
    }, true);
  });
};

exports.default = _default;

/***/ }),

/***/ 1455:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(1372);

var _default = function _default(validator) {
  return (0, _common.withParams)({
    type: 'not'
  }, function (value, vm) {
    return !(0, _common.req)(value) || !validator.call(this, value, vm);
  });
};

exports.default = _default;

/***/ }),

/***/ 1456:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(1372);

var _default = function _default(min) {
  return (0, _common.withParams)({
    type: 'minValue',
    min: min
  }, function (value) {
    return !(0, _common.req)(value) || (!/\s/.test(value) || value instanceof Date) && +value >= +min;
  });
};

exports.default = _default;

/***/ }),

/***/ 1457:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(1372);

var _default = function _default(max) {
  return (0, _common.withParams)({
    type: 'maxValue',
    max: max
  }, function (value) {
    return !(0, _common.req)(value) || (!/\s/.test(value) || value instanceof Date) && +value <= +max;
  });
};

exports.default = _default;

/***/ }),

/***/ 1458:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(1372);

var _default = (0, _common.regex)('integer', /^-?[0-9]*$/);

exports.default = _default;

/***/ }),

/***/ 1459:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _common = __webpack_require__(1372);

var _default = (0, _common.regex)('decimal', /^[-]?\d*(\.\d+)?$/);

exports.default = _default;

/***/ }),

/***/ 1894:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_configuration_open_modal__ = __webpack_require__(1433);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__ = __webpack_require__(1429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__);



var saveType = function () {
	var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
		var _this = this;

		var body;
		return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						body = {
							name: this.newType.name,
							number: Number(this.newType.level),
							toolId: Number(this.$route.params.toolId),
							toolCode: this.$route.params.toolCode
						};
						_context.prev = 1;
						_context.next = 4;
						return this.$store.dispatch('levelType/create', body);

					case 4:
						this.showNotification('Se cre\xF3 el nuevo nivel: "' + this.newType.name + '"', 'success');
						setTimeout(function () {
							_this.closeModal();
						}, 0);
						_context.next = 11;
						break;

					case 8:
						_context.prev = 8;
						_context.t0 = _context['catch'](1);

						if (_context.t0.data.message === 'NUMBER_NOT_VALID') {
							this.showNotification('El nivel ' + this.newType.level + ' ya est\xE1 asignado a otro registro', 'error');
						}

					case 11:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, this, [[1, 8]]);
	}));

	return function saveType() {
		return _ref.apply(this, arguments);
	};
}();

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




function closeModal() {
	var _$route$params = this.$route.params,
	    toolCode = _$route$params.toolCode,
	    toolId = _$route$params.toolId;

	var params = { toolCode: toolCode, toolId: toolId };
	this.goTo('levels-tool', { params: params });
}

function validations() {
	return {
		newType: {
			name: { required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"] },
			level: { required: __WEBPACK_IMPORTED_MODULE_3_vuelidate_lib_validators__["required"] }
		}
	};
}

function data() {
	return {
		newType: {
			name: '',
			level: ''
		}
	};
}

/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'new-type-form',
	components: {
		openModal: __WEBPACK_IMPORTED_MODULE_2__components_configuration_open_modal__["a" /* default */]
	},
	data: data,
	methods: {
		closeModal: closeModal,
		saveType: saveType
	},
	validations: validations
});

/***/ }),

/***/ 2299:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2300);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1266)("37961575", content, true, {});

/***/ }),

/***/ 2300:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1265)(true);
// imports


// module
exports.push([module.i, "@font-face{font-family:Lato_regular;src:url(\"/static/fonts/Lato-Regular.ttf\");font-weight:400;font-style:normal}@font-face{font-family:NeuzeitGroT;src:url(\"/static/fonts/NeuzeitGroT.eot\");src:url(\"/static/fonts/NeuzeitGroT.ttf\") format(\"truetype\"),url(\"/static/fonts/NeuzeitGroT.woff\") format(\"woff\");font-weight:400;font-style:normal}@font-face{font-family:NeuzeitGroTBold;src:url(\"/static/fonts/NeuzeitGroTBold.eot\");src:url(\"/static/fonts/NeuzeitGroTBold.ttf\") format(\"truetype\"),url(\"/static/fonts/NeuzeitGroTBold.woff\") format(\"woff\");font-weight:400;font-style:normal}@font-face{font-family:NeuzeitGroTLig;src:url(\"/static/fonts/NeuzeitGroLig.eot\");src:url(\"/static/fonts/NeuzeitGroTLig.ttf\") format(\"truetype\"),url(\"/static/fonts/NeuzeitGroTLig.woff\") format(\"woff\");font-weight:400;font-style:normal}@font-face{font-family:NeuzeitGroTBla;src:url(\"/static/fonts/NeuzeitGroTBla.eot\");src:url(\"/static/fonts/NeuzeitGroTBla.ttf\") format(\"truetype\"),url(\"/static/fonts/NeuzeitGroTBla.woff\") format(\"woff\");font-weight:400;font-style:normal}.type-form-container[data-v-84ecc17e]{height:200px}.type-form-container h2[data-v-84ecc17e]{border-bottom:1px solid #d5d5d5;padding-bottom:10px}.type-form-container form[data-v-84ecc17e]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start}.type-form-container form .name-input[data-v-84ecc17e]{-ms-flex-preferred-size:45%;flex-basis:45%;margin-right:20px;margin-top:20px}.type-form-container form .level-input[data-v-84ecc17e]{-ms-flex-preferred-size:7%;flex-basis:7%;margin-top:20px}", "", {"version":3,"sources":["/opt/build/repo/src/components/configuration/tools/new-type-form.vue"],"names":[],"mappings":"AACA,WACE,yBAA4B,AAC5B,0CAA2C,AAC3C,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,wBAA2B,AAC3B,yCAA0C,AAC1C,iHAAmH,AACnH,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,4BAA+B,AAC/B,6CAA8C,AAC9C,yHAA2H,AAC3H,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,2BAA8B,AAC9B,2CAA4C,AAC5C,uHAAyH,AACzH,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,2BAA8B,AAC9B,4CAA6C,AAC7C,uHAAyH,AACzH,gBAAoB,AACpB,iBAAmB,CACpB,AACD,sCACE,YAAc,CACf,AACD,yCACI,gCAAiC,AACjC,mBAAqB,CACxB,AACD,2CACI,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,uBAAwB,AACpB,oBAAqB,AACjB,0BAA4B,CACvC,AACD,uDACM,4BAA6B,AACzB,eAAgB,AACpB,kBAAmB,AACnB,eAAiB,CACtB,AACD,wDACM,2BAA4B,AACxB,cAAe,AACnB,eAAiB,CACtB","file":"new-type-form.vue","sourcesContent":["\n@font-face {\n  font-family: 'Lato_regular';\n  src: url(\"/static/fonts/Lato-Regular.ttf\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'NeuzeitGroT';\n  src: url(\"/static/fonts/NeuzeitGroT.eot\");\n  src: url(\"/static/fonts/NeuzeitGroT.ttf\") format(\"truetype\"), url(\"/static/fonts/NeuzeitGroT.woff\") format(\"woff\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'NeuzeitGroTBold';\n  src: url(\"/static/fonts/NeuzeitGroTBold.eot\");\n  src: url(\"/static/fonts/NeuzeitGroTBold.ttf\") format(\"truetype\"), url(\"/static/fonts/NeuzeitGroTBold.woff\") format(\"woff\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'NeuzeitGroTLig';\n  src: url(\"/static/fonts/NeuzeitGroLig.eot\");\n  src: url(\"/static/fonts/NeuzeitGroTLig.ttf\") format(\"truetype\"), url(\"/static/fonts/NeuzeitGroTLig.woff\") format(\"woff\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'NeuzeitGroTBla';\n  src: url(\"/static/fonts/NeuzeitGroTBla.eot\");\n  src: url(\"/static/fonts/NeuzeitGroTBla.ttf\") format(\"truetype\"), url(\"/static/fonts/NeuzeitGroTBla.woff\") format(\"woff\");\n  font-weight: normal;\n  font-style: normal;\n}\n.type-form-container[data-v-84ecc17e] {\n  height: 200px;\n}\n.type-form-container h2[data-v-84ecc17e] {\n    border-bottom: 1px solid #d5d5d5;\n    padding-bottom: 10px;\n}\n.type-form-container form[data-v-84ecc17e] {\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: start;\n        -ms-flex-pack: start;\n            justify-content: flex-start;\n}\n.type-form-container form .name-input[data-v-84ecc17e] {\n      -ms-flex-preferred-size: 45%;\n          flex-basis: 45%;\n      margin-right: 20px;\n      margin-top: 20px;\n}\n.type-form-container form .level-input[data-v-84ecc17e] {\n      -ms-flex-preferred-size: 7%;\n          flex-basis: 7%;\n      margin-top: 20px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 2301:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('open-modal',{attrs:{"title":"Guardar","color":"primary","create":_vm.$v.$invalid,"dialog":true},on:{"close-modal":_vm.closeModal,"create-employee":_vm.saveType}},[_c('div',{staticClass:"type-form-container"},[_c('h2',[_vm._v("Nuevo Tipo")]),_vm._v(" "),_c('form',{style:(("color:" + (_vm.$appColors.info)))},[_c('label',{staticClass:"name-input"},[_vm._v("\n\t\t\t\tNombre\n\t\t\t\t"),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.newType.name),expression:"newType.name"}],staticClass:"new-survey-input",attrs:{"placeholder":"Nombre"},domProps:{"value":(_vm.newType.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.newType, "name", $event.target.value)}}})]),_vm._v(" "),_c('label',{staticClass:"level-input"},[_vm._v("\n\t\t\t\tNivel\n\t\t\t\t"),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.newType.level),expression:"newType.level"}],staticClass:"new-survey-input",domProps:{"value":(_vm.newType.level)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.newType, "level", $event.target.value)}}})])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/58.a616264ce6455b3d2487.js